import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useOrganization } from '@/context/organization-context';

import { paths } from 'src/routes/paths';
import { ClientManagement } from 'src/components/settings/ClientManagement';

export const Route = createFileRoute('/_authed/dashboard/o/$orgId/settings/client/brand/')({
  component: ManageSection,
});

function ManageSection() {
  const { isOwner } = useOrganization();
  const navigate = useNavigate();
  const { orgId } = Route.useParams();
  const isUserOwner = isOwner();

  useEffect(() => {
    if (!isUserOwner) {
      navigate({ to: paths.dashboard.orgSettings(orgId).client.brandProfiles, replace: true });
    }
  }, [isUserOwner, navigate, orgId]);

  if (!isUserOwner) return null;

  return <ClientManagement />;
}
